<template lang="html">

  <div>
    <div v-if="isSignedIn">

      <p>Du er logget ind som {{name}}.<br>Klik her for at logge ud</p>

      <div class="logoutbutton" width="360px" @click="signOut">
        <div class="custom_abcRioButton custom_abcRioButtonLightBlue">
          <div class="custom_abcRioButtonContentWrapper">
            <div class="custom_abcRioButtonIcon" style="padding:8px">
              <div style="width:18px;height:18px;" class="custom_abcRioButtonIconImage custom_abcRioButtonIconImage18">
                <i class="material-icons" id="logout_arrow">arrow_back</i>
              </div>
            </div>
            <span style="font-size:13px;line-height:34px;" class="custom_abcRioButtonContents">Sign out</span></div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>


 export default {
  name: 'Login',
  props: {
    isSignedIn: Boolean,
    name: String
  },
  methods: {
    signOut: function() {
      this.$emit('signed-out');

      var auth2 = window.gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        console.log('User signed out.');
      });
       window.location.assign("/");

    }
  }

}


</script>

<style lang="css" scoped>

#logout_arrow {
  line-height: 0.75em;
}
.logoutbutton{
  width: 300px;
  display: inline-block;
  margin: auto;
}


/* google stying */
.custom_abcRioButton {
  -webkit-border-radius: 1px;
  border-radius: 1px;
  -webkit-box-shadow: 0px 2px 4px 0px rgba(0,0,0,.25);
  box-shadow: 0px 2px 4px 0 rgba(0,0,0,.25);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: background-color .218s,border-color .218s,box-shadow .218s;
  transition: background-color .218s,border-color .218s,box-shadow .218s;
  -webkit-user-select: none;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  color: #262626;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  position: relative;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
}
.custom_abcRioButtonLightBlue {
    background-color: #fff;
    color: #757575;
}
.custom_abcRioButtonContentWrapper {
    height: 100%;
    width: 100%;
}
.custom_abcRioButtonIcon {
    float: left;
}
.custom_abcRioButtonContents {
    font-family: Roboto,arial,sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: .21px;
    margin-left: 6px;
    margin-right: 6px;
    vertical-align: top;
    text-align: center;
}

</style>
